import { INotificationMessage } from "@fl/shared/src/types/messages";
import StringsFuncs from "./stringsFuncs";

class ParamsFuncs {
  private search: string;
  private params: URLSearchParams;
  constructor(search: string) {
    this.search = search;
    this.params = new URLSearchParams(this.search);
  }

  getMessages = (): INotificationMessage[] => {
    const message = this.params.get("message");

    if (message) {
      const header = this.params.get("header")
        ? this.params.get("header")!
        : "";
      const variant: any = this.params.get("variant");
      const key: string = new StringsFuncs().generateCode();

      return [
        {
          header,
          variant,
          message,
          key,
          show: true,
          date: new Date(),
        },
      ];
    } else {
      return [];
    }
  };

  getConfirmUser = () => {
    const id = this.params.get("id");
    const codigo = this.params.get("codigo");
    return { id, codigo };
  };
}

export default ParamsFuncs;
